import { createCache } from './cache';

export const mapCache = createCache()
